import React from "react"
import PropTypes from "prop-types"
import lottie from 'lottie-web';

class PurchaseSuccess extends React.Component {

  constructor(props) {
    super(props)

    this.state = {
      show: true,
      id: ''
    }

    this.loadLottie = this.loadLottie.bind(this)
  }

  loadLottie() {
    const containerId = this.props.containerId || 'badgeAlert'
    const container = document.getElementById(containerId)
    if (!container) return

    lottie.loadAnimation({
      container: container,
      renderer: 'svg',
      name: 'badgeAlert',
      loop: false,
      autoplay: true,
      speed: .1,
      path: this.props.confettiLottie
    });
  }

  componentDidMount() {
    this.setState({
      show: true,
    })
    this.loadLottie()
  }


  render() {
    const containerId = this.props.containerId || 'badgeAlert'
    const isEmbedded = Boolean(this.props.containerId)

    return(
      <div style={isEmbedded ? {} : { marginTop: 20 }}>
        <div
          id={containerId}
          style={
            isEmbedded
              ? { width: '100%', height: '100%' }
              : { justifyContent: 'center', height: 500, marginTop: -250 }
          }
        />
      </div>
    )
  }
}


export default PurchaseSuccess
